<template>
  <div class="" id="top">
    <div class="banner pb-1 offset-lg-1 d-print-none" v-if="!fullscreen">
      <img src="./assets/img/banner.jpg" class="img-fluid d-block ml-lg-3">
    </div>
    <div class="d-print-none">
      <div class="row pb-2 pt-2 pl-0 pr-0 mr-0 ml-0" v-if="!fullscreen">
        <div class="col-lg-7 offset-lg-1 my-auto">
          <div class="font-weight-bold">{{ _.title }} {{ mode.displayType }} browse by {{ mode.title }}</div>
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" v-model="search"
                   v-on:keyup.enter="doSearch()">
            <div class="input-group-append">
              <button class="btn bg-white border-top border-bottom" v-on:click="resetSearch()"
                      v-if="search.length > 0">
                <icon :icon="['fad', 'times']"/>
              </button>
              <div class="input-group-text">
                <icon :icon="['fad', 'search']" v-on:click="doSearch()"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-primary d-print-none" v-if="!fullscreen">
      <nav class="col-10 offset-1 navbar navbar-expand-lg navbar-dark pl-0 pr-2 mb-3 font-weight-bold">
        <ul class="navbar-nav nav-pills float-left ml-lg-2" v-on:click="search = ''">
          <router-link class="nav-link" to="/home">
            <icon :icon="['fad', 'home']" class=""/>
            Home
          </router-link>
        </ul>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler"
                aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarToggler">
          <ul class="navbar-nav nav-pills ml-lg-5 text-lg-center">
            <router-link class="nav-link my-auto" to="/view">
              Browse by:
            </router-link>
            <li class="nav-link" :title="_.groupedCapital"
                v-on:click="setGrouped(true, _.grouped,'name', 'order', 'asc')">
            <span class="router-link-active" v-if="mode.grouped.field === 'name'"><icon
                :icon="['fad', 'layer-group']"/> {{ _.groupedCapital }}</span>
              <span class="pointer-click" v-else><icon :icon="['fad', 'layer-group']"/> {{ _.groupedCapital }}</span>
            </li>
            <li class="nav-link" title="Authors"
                v-on:click="setGrouped(true, 'authors','lastname', 'lastname', 'asc', true)">
            <span class="router-link-active" v-if="mode.grouped.field === 'lastname'"><icon
                :icon="['fad', 'users']"/> Authors</span>
              <span class="pointer-click" v-else><icon :icon="['fad', 'users']"/> Authors</span>
            </li>
            <li class="nav-link" title="Title"
                v-on:click="setGrouped(false, 'titles','title', 'title', 'asc')">
            <span class="router-link-active" v-if="mode.grouped.field === 'title'"><icon
                :icon="['fad', 'sort-alpha-down']"/> Titles</span>
              <span class="pointer-click" v-else><icon :icon="['fad', 'sort-alpha-down']"/> Titles</span>
            </li>
          </ul>
          <ul class="navbar-nav nav-pills ml-auto d-none d-lg-inline-flex">
            <div class="text-white p-2 mr-1">
              <span class="pointer-click" v-on:click="$store.state.thumbnails = !$store.state.thumbnails">Thumbnails&nbsp;</span>
              <icon :icon="['fad', 'check-square']" class="text-white pointer-click"
                    title="Toggle thumbnails" v-if="thumbnails === true" v-on:click="$store.state.thumbnails = false"/>
              <icon :icon="['fad', 'square']" class="text-white pointer-click"
                    title="Toggle thumbnails" v-else v-on:click="$store.state.thumbnails = true"/>
            </div>
            <router-link class="nav-link my-auto" to="/view">
              View type
            </router-link>
            <li class="nav-link" v-on:click="setMode('wall')">
              <icon :icon="['fad', 'grip-lines']" class="router-link-active" v-if="mode.displayType === 'wall'"
                    title="View type lines"/>
              <icon :icon="['fad', 'grip-lines']" class="pointer-click" title="View type lines" v-else/>
            </li>
            <li class="nav-link" v-on:click="setMode('cards')">
              <icon :icon="['fad', 'grip-horizontal']" class="router-link-active"
                    v-if="mode.displayType === 'cards'"
                    title="View type cards"/>
              <icon :icon="['fad', 'grip-horizontal']" class="pointer-click" v-else title="View type cards"/>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div>
      <router-view />
    </div>
    <div class="border-top my-auto d-flex d-print-none">
      <div class="mx-auto d-inline-flex">
        <div class="my-auto">designed by&nbsp;
          <img src="./assets/img/documedias_logo.png" class="img-fluid my-auto" style="height: 14px;"></div>
        <router-link class="nav-link my-auto pr-1" to="/impress">
          Impress
        </router-link>
        <router-link class="nav-link my-auto pl-1" to="/privacypolicy">
          Privacy Policy
        </router-link>
      </div>
    </div>
    <vue-cookie-accept-decline
        :ref="'myPanel1'"
        :elementId="'myPanel1'"
        :debug="false"
        :position="'top'"
        :type="'bar'"
        :disableDecline="false"
        :transitionName="'slideFromBottom'"
        :showPostponeButton="false"
        @status="cookieStatus"
        @clicked-accept="cookieClickedAccept"
        @clicked-decline="cookieClickedDecline">
      <!-- Optional -->
      <div slot="postponeContent">
        &times;
      </div>
      <!-- Optional -->
      <div slot="message">
        We use cookies to ensure you get the best experience on our website. <a href="https://cookiesandyou.com/"
                                                                                target="_blank">Learn More...</a>
        <br>See our
        <router-link to="/privacypolicy">Privacy Policy</router-link>
      </div>
      <!-- Optional -->
      <div slot="declineContent">
        Decline
      </div>
      <!-- Optional -->
      <div slot="acceptContent">
        Accept
      </div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  data: function () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapState([
      'posters', 'fullscreen', 'mode', "thumbnails"
    ]),
  },
  methods: {
    setMode(mode) {
      this.$route.params.poster = '';
      this.$store.state.mode.displayType = mode;
      this.$router.push('/view');
    },
    setGrouped(grouped_status, mode_title, grouped_field = '', grouped_order = 'order', grouped_sort = 'asc', grouped_compact = false) {
      this.$store.state.loader = true;
      this.$store.state.openCollapse = 'group0';
      this.$store.state.mode.grouped.status = grouped_status;
      this.$store.state.mode.grouped.field = grouped_field;
      this.$store.state.mode.grouped.sort = grouped_sort;
      this.$store.state.mode.grouped.order = grouped_order;

      if (grouped_status === false) {
        this.$store.state.mode.order = grouped_order;
      }
      this.$store.state.mode.title = mode_title;
      this.$store.state.mode.grouped.compact = grouped_compact;

      this.$store.state.posters = [];
      this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
      this.$router.push('view');
    },
    doSearch() {
      this.$store.state.loader = true;
      if (this.search.length > 0) {
        this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'search', this.search);
        let searchObject = {search: this.search, mode: this.$store.state.mode}
        this.$store.dispatch('GET_POSTERS', searchObject);
      } else {
        this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
      }
      this.$router.push('view')
    },
    resetSearch() {
      this.search = '';
      this.doSearch();
    },
    cookieClickedDecline() {
      alert('tracking disabled for this session.');
      this.$ga.disable()
    },
    cookieStatus(status) {
      this.status = status
    },
    cookieClickedAccept() {
      this.status = 'accept'
    },
    cookieRemovedCookie() {
      this.status = null
      this.$refs.myPanel1.init()
    },

    removeCookie() {
      this.$refs.myPanel1.removeCookie()
    }
  },
  created() {
    this.$store.state.loader = true;
    this.$store.dispatch('GET_ALL_RATINGS');
    this.$store.dispatch('GET_STATISTICS');
    this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
  }
}
</script>

<style lang="scss">
@import './assets/styles/custom-bootstrap.scss';
@import "~bootstrap/scss/bootstrap";
</style>
